import { render, staticRenderFns } from "./AttachClientFilesList.vue?vue&type=template&id=b90bb4ea&scoped=true"
import script from "./AttachClientFilesList.vue?vue&type=script&lang=js"
export * from "./AttachClientFilesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90bb4ea",
  null
  
)

export default component.exports